export default "__VITE_ASSET__DwTU7mI___"